import interactiveStreetView from './components/_interactive_street_view_component'
import trackMapService from './services/track_map_service'

window.bz_map_module = angular
  .module('bzMapModule', [])
  .component('interactiveStreetView', interactiveStreetView)
  .factory('trackMapService', trackMapService)
